import DescriptionIcon from "../../../../Component/Elements/Icon/DescriptionIcon/DescriptionIcon";
import CSS from "./static/css/ContractDocsImgViewIconBtn.module.css";
import { useMemo } from "react";
import Text from "../../../../Component/Elements/Text/Text";
import ReactPhotoSwipeIconVersion from "../../../../Component/Elements/ReactPhotoSwipeGallery/ReactPhotoSwipeIconVersion";
import useIsMobile from "../../../../Common/hooks/useIsMobile";
import usePhotoImageDataListREST from "../../../ProductManufacturing/hooks/REST/usePhotoImageDataListREST";
import { customParseInt, dev_console, getAccountData } from "../../../../Common/ts/commonTools";
import { FILE_USAGE_CD } from "../../../ProductManufacturing/static/interface/ProductItemPhoto.interface";

const ContractDocsImgViewIconBtn = (
    {
        label,
        className,
        contract_id,
    }:{
        label?: string;
        className?: string

        /** 계약번호 - 계약서 이미지 데이터 요청 시 사용 */
        contract_id: string;
    }
) => {
    const isMobile = useIsMobile();

    const mainClassName = useMemo(() => {
        const RTN: string[] = [];

        if(className){
            RTN.push(className);
        }

        RTN.push(CSS.l_ContractDocsImgViewIconBtn_main)

        return RTN.join(" ");
    }, [className])

    // 2026.01.29 - 김효민 - 계약서 이미지 데이터 요청
    const {
        photoImageDataListData,
        photoImageDataListIsLoading,
        photoImageDataListError,
        photoImageDataListRefetch,
    } = usePhotoImageDataListREST({
        brand_id: getAccountData.brand_id(),
        data_pk: customParseInt(contract_id) || 0,
        file_usage_cd: FILE_USAGE_CD.CONTRACT,
    })

    const contractImageList = useMemo(() => {
        if(photoImageDataListData && photoImageDataListData.data.length > 0){
            return photoImageDataListData.data[0].upload_file_detail_data.map((img) => img.middle_img);
        }
        return [];
    }, [photoImageDataListData])

    return(
        <div
            className={mainClassName}
        >
            {
                label
                &&  <Text
                        size={"size3"}
                        color={"gray2"}
                    >
                        {label}
                    </Text>
            }

            {
                contractImageList.length > 0
                &&  <ReactPhotoSwipeIconVersion
                        img_list={contractImageList}
                    >
                        <DescriptionIcon
                            size={isMobile ? "medium" : "small"}
                            onClick={() => {
                                // react-photoswipe-gallery의 모달을 뒤로가기를 통해 닫게하기 위한 코드
                                window.history.pushState({ modal: true }, '');
                            }}
                        />
                    </ReactPhotoSwipeIconVersion>
            }
        </div>
    )
}

export default ContractDocsImgViewIconBtn;